import { BrowserRouter } from 'react-router-dom';
import './App.css';
import '../src/assets/style.scss';
import '../src/assets/global.scss';
import Router from './Router';
import { Provider } from 'react-redux';
import { store } from './redux/store';

function App() {
  return (
    <div className="App">
      <Provider store={store}>
        <BrowserRouter>
          <Router />
        </BrowserRouter>
      </Provider>
    </div>
  );
}

export default App;
